/**
 * patch-pop-legal.js
 * PATCHPOP Bilingual Legal Page — Language Toggle
 * Self-contained, no dependencies, no framework.
 */

(function () {
  'use strict';

  var STORAGE_KEY = 'pp-legal-lang';
  var VALID_LANGS = ['en', 'ar'];

  function initLegalPage(section) {
    // Duplicate-init guard: skip if this section is already initialized.
    // shopify:section:load clears dataset on re-render so the guard resets automatically.
    if (section.dataset.ppLegalInit === 'true') return;
    section.dataset.ppLegalInit = 'true';

    var btns = section.querySelectorAll('.pp-legal-lang__btn');
    if (!btns.length) return;

    // Resolve initial language: stored session preference → data attribute → 'en'
    var stored;
    try { stored = sessionStorage.getItem(STORAGE_KEY); } catch (e) {}
    var initial = (stored && VALID_LANGS.indexOf(stored) !== -1)
      ? stored
      : (section.getAttribute('data-active-lang') || 'en');

    function setLang(lang) {
      if (VALID_LANGS.indexOf(lang) === -1) return;

      // Update data attribute (controls CSS visibility and direction)
      section.setAttribute('data-active-lang', lang);

      // Sync lang and dir attributes for accessibility and screen readers
      section.setAttribute('lang', lang);
      section.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');

      // Update button active states
      btns.forEach(function (btn) {
        var active = btn.getAttribute('data-lang') === lang;
        btn.classList.toggle('pp-legal-lang__btn--active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      try { sessionStorage.setItem(STORAGE_KEY, lang); } catch (e) {}
    }

    // Wire up language buttons
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setLang(btn.getAttribute('data-lang'));
      });
    });

    setLang(initial);
  }

  function initAll() {
    document.querySelectorAll('.pp-legal-page').forEach(initLegalPage);
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify Theme Editor: re-init when a section reloads
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.pp-legal-page');
    if (section) initLegalPage(section);
  });
})();
